import * as actions_service_requests from 'actions/service-requests-actions';
import * as actions_users from 'actions/users-actions';
import * as toolbox from 'components/common/toolbox';
import React, { useEffect, useState } from 'react';
import ResultsActionIcons from './results-actions/results-action-icons';
import _ from 'lodash';
import moment from 'moment';
import { APPS, SERVICE_REQUEST_TERMS, WORKORDERS } from 'components/constants';
import { Avatar } from 'enspire-manager-framework';
import { DashboardDetail } from 'enspire-manager-framework';
import { Table } from 'em-table';
import { imageSize, navMultipleUrls, numPanels } from 'components/common/toolbox';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

const ResultsWorkOrders = (props) => {
    
    /* Hooks --------------------------*/
    
    const params = useParams();
    const history = useHistory();
    const dispatch = useDispatch();
	const routeLocation = useLocation();

    const employees = useSelector((store) => store.employees.employees);
    const user = useSelector((store) => store.users.user);
    const workOrders = useSelector((store) => store.workOrders);

    const [data, setData] = useState([]);

    const type = (params.appId == APPS.DISPATCH.id) ? 'service_request' : 'asset_request';
    const typeWorkOrders = _.filter(workOrders.work_orders_open, (wo) => wo['type'] == type);
    const orderedWorkOrders = _.orderBy(typeWorkOrders, ['_name'], ['asc']);
	const segments = routeLocation.pathname.split('/').length;

    /* UseEffect --------------------------*/

    useEffect(() => {

        var filteredWorkOrders = [];
        if (params.widget_id == 'unassigned-wo') {
            filteredWorkOrders = _.filter(orderedWorkOrders, (wo) => wo.statusId == WORKORDERS.UNASSIGNED.id);
        } else if (params.widget_id == 'incomplete-wo') {
            filteredWorkOrders = _.filter(orderedWorkOrders, (wo) => wo.statusId == WORKORDERS.INCOMPLETE.id);
        } else if (params.widget_id == 'inprogress-wo') {
            filteredWorkOrders = _.filter(orderedWorkOrders, (wo) => [
                WORKORDERS.ASSIGNED.id,
                WORKORDERS.PAUSED.id,
                WORKORDERS.ENROUTE.id, 
                WORKORDERS.ONSITE.id, 
                WORKORDERS.INPROGRESS.id, 
            ].includes(wo.statusId));
        } else if (params.widget_id == 'complete-wo') {
            filteredWorkOrders = _.filter(orderedWorkOrders, (wo) => wo.statusId == WORKORDERS.COMPLETE.id);
        }
        
        var work_orders = [];
        var currentEntityId = null;
        filteredWorkOrders?.forEach((workOrder) => {
            
            const entityId = (params.appId == APPS.DISPATCH.id) ? workOrder.customerId : workOrder.assetId;
            const status = _.find(Object.values(WORKORDERS), { id: workOrder.statusId });
            const technician = _.find(employees, (o) => o.id == workOrder?.technicianId);
            const name = (technician) ? technician.contact?.firstName + ' ' + technician.contact?.lastName : 'Unassigned';
            const owner = _.find(employees, (o) => o.contact?.email == workOrder?.ownerId);

            // Add grouip heading for customer or asset
            if (entityId != currentEntityId) {
                currentEntityId = entityId;
                work_orders.push({ ...workOrder,
                    status: status?.name,
                    _jsx:
                    <div className="d-flex align-items-center justify-content-between p-2" style={{ backgroundColor: '#dddddd' }}>
                        <div role="button" onClick={() => openEntity(workOrder)}>
                            <Avatar className=""
                                color="white"
                                bgColor="saddleBrown"
                                size={45}
                                fontSize={'20px'}
                                name={(params.appId == APPS.DISPATCH.id) ? workOrder._displayName : workOrder._name}
                                image={imageSize(workOrder._imageUrl, 'sm')}
                                imageWidth={60}
                                border="4px solid white"
                                role={ (workOrder._imageUrl) ? "button" : null }
                                style={{ flexShrink: 0 }}
                            />
                        </div>
                        <div className="flex-grow-1">
                            <h2 className="ml-3 m-0 text-black font-weight-normal">{
                                ((params.appId == APPS.DISPATCH.id) ? workOrder._displayName : workOrder._name) + 
                                ((workOrder._unitNumber) ? ' #' + workOrder._unitNumber : '')
                            }</h2>
                            { workOrder._address &&
                                <p className="ml-3 m-0">{ workOrder._address }</p>
                            }
                        </div>
                    </div> 
                });
            }

            work_orders.push({ ...workOrder,
                status: status?.name,
                _stripe_color: status?.color,
                details: <>
                    <div className="d-flex align-items-center flex-wrap">
                        { workOrder?.technicianId && workOrder?.technicianId != 'unassigned' &&
                            <Avatar
                                color="white"
                                bgColor="steelblue"
                                size={50}
                                fontSize={'18px'}
                                name={name}
                                image={technician?.contact.photoUrl ? imageSize(technician?.contact.photoUrl, 'sm') : null}
                                border='4px solid white'
                            />
                        }
                        <div>
                            <div className="d-flex justify-content-between">
                                <h1 className="main-heading heading-work-order align-self-start mx-2">
                                    WO #{workOrder.customId}
                                </h1>
                                <p className="mb-2 mr-auto">{ moment(workOrder.startDate?.toDate()).format('MMM Do, YYYY h:mm A') }</p>
                            </div>
                            { workOrder?.technicianId && workOrder?.technicianId != 'unassigned' &&
                                <h4 className="m-0 ml-2">{`${technician?.contact?.firstName} ${technician?.contact?.lastName}`}</h4>
                            }
                        </div>
                    </div>
                    <div className="d-flex align-items-end mb-2">
                        <div id="work-order-details" className="flex-grow-1 mt-2 mr-3">
                            <DashboardDetail field={ 'Description' } value={ workOrder.description } type="text" />
                            <DashboardDetail field={ 'Suggested' } value={ workOrder.suggested } type="text" />
                            <DashboardDetail field={ 'Created By' } value={ (owner) ? `${owner?.contact.firstName} ${owner?.contact.lastName}` : '' } type="text" />
                            { workOrder.reason &&
                                <div className="alert alert-warning mb-0 mt-2">
                                    <strong>REASON:</strong>&nbsp; { workOrder.reason }
                                </div>
                            }
                            <div className="clearfix"></div>
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                        <ResultsActionIcons entity={ 'workOrder' } entityId={ workOrder.id } workOrder={ workOrder } sms={ true } />
                        <button className="btn btn-default btn-lg btn-circle ml-3" onClick={ () => openWorkOrder(workOrder) }>
                            <i className="fa-duotone fa-solid fa-chevrons-right"></i>
                        </button>
                    </div>
                </>
            });
        });
        setData(work_orders);
    }, [workOrders.work_orders_open, routeLocation.pathname]);

    /* Actions ----------------------------*/

    const openWorkOrder = async (workOrder) => {
        let num = (segments >= 11) ? -2 : (segments >= 10) ? -1 : 0;
        if (num) history.go(num);

        const entityId = (params.appId == APPS.DISPATCH.id) ? workOrder.customerId : workOrder.assetId;
        const serviceRequest = await actions_service_requests.getServiceRequestById(params.handle, workOrder.serviceRequestId);
        
        if (serviceRequest.serviceRequestTermsId == SERVICE_REQUEST_TERMS.SERVICE_CALL.id) {
            navMultipleUrls({ actions_users, dispatch, history, numPanels, params, user, urlArray: [
                toolbox.modifyPath( routeLocation?.pathname, 4, `${entityId}/form/0/service_requests`, 7),
                toolbox.modifyPath( routeLocation?.pathname, 4, `${entityId}/form/0/service_requests/${workOrder.serviceRequestId}/work_orders/${workOrder.id}/items`, 11),
            ]});
        } else {
            navMultipleUrls({ actions_users, dispatch, history, numPanels, params, user, urlArray: [
                toolbox.modifyPath( routeLocation?.pathname, 4, `${entityId}/form/0/service_requests`, 7),
                toolbox.modifyPath( routeLocation?.pathname, 4, `${entityId}/form/0/service_requests/${workOrder.serviceRequestId}/work_orders`, 9),
                toolbox.modifyPath( routeLocation?.pathname, 4, `${entityId}/form/0/service_requests/${workOrder.serviceRequestId}/work_orders/${workOrder.id}/items`, 11),
            ]});
        }
    }
    const openEntity = (workOrder) => {
        const entityId = (params.appId == APPS.DISPATCH.id) ? workOrder.customerId : workOrder.assetId;
        const tab = (params.appId == APPS.DISPATCH.id) ? 'tab' : 'service_requests';

        navMultipleUrls({ actions_users, dispatch, history, numPanels, params, user, urlArray: [
            toolbox.modifyPath( routeLocation?.pathname, 4, `${entityId}/form/0/${tab}`, 7),
        ]});    
    }

    /* Constants --------------------------*/

    const columns = [
        { name: 'Details', field: 'details', type: 'jsx', width: 100 },
    ];

    return (

        <Table
            data={data}
            columns={columns}
            header_style={{border: 'none'}}
            active_field={'id'}
            active_id={params.tab2_id}
            group_by={{ fields: ['statusId'], direction: ['desc'], display: ['status'] }}
            hide_header={true}
        >
        </Table>
    );
};

export default ResultsWorkOrders;